export default __webpack_public_path__ + "static/Simple_Shotgun_Ammo-5154fe5d4edc9035e57bebb9481dd317.png";